module.exports = __webpack_public_path__ + "static/media/rightlf.4fcf3ef5.png";